import { ApiEpBilling } from "@smp/api";
import { useQuery, useQueryClient } from "react-query";

const KEY = "ep.billing.account";

export const useEpBillingAccount = () => {
  const queryClient = useQueryClient();

  const { data: accountList, isLoading: isAccountListLoading } = useQuery(
    KEY,
    () => ApiEpBilling.Account.list({}),
  );

  const accountInvalidate = () => {
    queryClient.invalidateQueries(KEY);
  };

  return { accountInvalidate, accountList, isAccountListLoading };
};

useEpBillingAccount.KEY = KEY;
